import { useState } from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { toISO } from "@/lib/residences";

const parse = (iso) => (iso ? new Date(`${iso}T12:00:00`) : undefined);

export default function DateField({ value, onChange, min, disabledDates = [], placeholder = "jj/mm/aaaa", testid, className = "" }) {
  const [open, setOpen] = useState(false);
  const minDate = parse(min);
  if (minDate) minDate.setHours(0, 0, 0, 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`w-full flex items-center gap-2 bg-white border border-[#EFE6DB] rounded-xl px-3 py-3 text-sm text-left outline-none focus:border-[#38B5D8] ${className}`}>
          <CalendarDays className="w-4 h-4 shrink-0 text-[#38B5D8]" />
          <span data-testid={testid && `${testid}-value`} className={value ? "text-[#17252B]" : "text-[#71828A]"}>{value ? format(parse(value), "dd/MM/yyyy") : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-white z-[120]">
        <Calendar locale={fr} mode="single" showOutsideDays={false} selected={parse(value)} defaultMonth={parse(value) || minDate}
          disabled={[...(minDate ? [{ before: minDate }] : []), ...disabledDates]}
          onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }} />
        {value && <button type="button" data-testid={testid && `${testid}-clear`} onClick={() => { onChange(""); setOpen(false); }} className="w-full text-xs font-semibold text-[#71828A] py-2 border-t border-[#EFE6DB]">Effacer</button>}
      </PopoverContent>
    </Popover>
  );
}
